import { atom } from "jotai";

/**
 * TODO: To be extracted to a `device` package.
 *
 * Should contain the version of the device. For web it could be the browser version if accessible.
 * For Tizen it will be the version of the OS.
 */
export const deviceVersionAtom = atom<string | undefined>(undefined);
